export type IntervalDataEmptyVariant =
  | "load_error"
  | "no_capability"
  | "no_points"
  | "too_many_points"

interface ResolveIntervalChartViewOptions {
  fetchedPointCount: number
  hasIntervalCapability: boolean
  hasLoadError: boolean
  isWindowTooDense: boolean
}

export const resolveIntervalChartView = ({
  fetchedPointCount,
  hasIntervalCapability,
  hasLoadError,
  isWindowTooDense,
}: ResolveIntervalChartViewOptions): IntervalDataEmptyVariant | null => {
  if (hasLoadError) {
    return "load_error"
  }
  if (!hasIntervalCapability) {
    return "no_capability"
  }
  if (isWindowTooDense) {
    return "too_many_points"
  }
  if (fetchedPointCount === 0) {
    return "no_points"
  }
  return null
}
